module.exports = __webpack_public_path__ + "img/catch-features.dfe71fc8.svg";